import axios from 'axios';
import { SpinnerIndicator } from 'components/CallServer';
import * as React from 'react';
import { RoutePaths } from 'routes/RouteConfig';

interface IState {
    hasError: boolean;
    writingLog: boolean;
    logId: number;
    error: any;
}

interface IProps {
}

export default class ErrorBoundary extends React.Component<IProps, IState> {
    private logEnabled = process.env.NODE_ENV !== 'development';

    constructor(props: IProps) {
        super(props);
        this.state = { hasError: false, error: null, logId: null, writingLog: false };
    }

    private logEvent(message: string, stack: string) {
        this.setState({ writingLog: true, hasError: true, logId: null, error: { message, stack } });

        axios({
            url: "/api/App/WriteLog",
            method: "post",
            data: { message, stack },
            headers: {
                responseType: "json",
                "Content-Type": "application/json"
            }
        })
            .then((result: any) => {
                const { status, data } = result;
                var id = (status == 200) ? (data as number) : -1;
                this.setState({ logId: id, writingLog: false });
            })
            .catch(() => {
                this.setState({ writingLog: false });
            });
    }

    static getDerivedStateFromError(error: any) {
        // Atualize o state para que a próxima renderização exiba a UI de fallback.
        return { hasError: true, error: error };
    }

    public componentDidCatch(error: Error, errorInfo: any) {
        this.logEvent(error.message, error.stack);
    }

    public componentDidMount() {
        if (this.logEnabled) {
            window.onerror = async (message: any, file: any, line: number, column: number, errorObject: any) => {

                if (!this.state.writingLog) {
                    column = column || (window.event && (window.event as any).errorCharacter);
                    var stack = errorObject ? errorObject.stack : null;
                    this.logEvent(message, stack);
                }

                return false;
            };
        }
    };

    public render() {

        const { writingLog, hasError, logId, error } = this.state;

        if (hasError) {
            return this.logEnabled
                ? (
                    <div style={{ width: 600, margin: "0 auto", marginTop: 80, padding: 20, border: "solid 1px red" }}>
                        <div style={{ textAlign: "center" }}>

                            <h1 style={{ color: "red" }}>
                                <span>Ocorreu um erro durante a execução do aplicativo</span>
                                <br />
                                <span>An error occurred while running the application</span>
                            </h1>

                            <div style={{ marginTop: 40 }}>

                                <p>
                                    <span>Se o problema persistir, por favor, entre em contato com o administrador do sistema.</span>
                                    <br />
                                    <span>If the problem persists, please contact your system administrator.</span>
                                </p>

                                <p>
                                    <span>Por favor, retorne à página inicial clicando no botão abaixo.</span>
                                    <br />
                                    <span>Please return to the home page by clicking the button below.</span>
                                </p>

                                {
                                    writingLog
                                        ? <p><SpinnerIndicator />Escrevendo log // Writing log...</p>
                                        : logId
                                            ? <p><b>Id para inspeção // Inspection Id:</b> {logId}</p>
                                            : null
                                }

                                <button
                                    style={{ padding: 10 }}
                                    type="button"
                                    onClick={() => { document.location.replace(RoutePaths.TimelineStartup); }}>
                                    <span>Página Inicial // Home Page</span>
                                </button>

                                <div style={{ marginTop: 20, textAlign: "left", color: "darkred" }}>
                                    <details>
                                        <div>
                                            <b>{error.message}</b>
                                        </div>
                                        <code>
                                            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", textOverflow: "clip" }}>
                                                {error.stack}
                                            </pre>
                                        </code>
                                    </details>
                                </div>

                            </div>
                        </div >
                    </div >
                )
                : null;
        }

        return this.props.children;
    }
}